import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';


const PublicModalWrappers = ( props ) => (
  <Modal
    isOpen={props.isOpen}
    toggle={props.close}
    centered
    contentClassName="CriteriaModal_wrapper"
    backdropClassName="CriteriaModal_background"
    size="lg"
    style={{width:  props.width ? props.width : '80%'}}
  >
  {props.children}
  </Modal>
);

PublicModalWrappers.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default PublicModalWrappers;
